import type {ReactElement} from 'react';
import React from 'react';
import {FONT_SIZE_MAX, FONT_SIZE_MIN} from '@PosterWhiteboard/items/text-item/text-item.types';
import {ExponentialSliderOptions} from '@Components/exponential-slider-options/exponential-slider-options';
import {InputFieldSize} from '@Components/input-field-v2/input-field.types';
import styles from './base-font-size-option.module.scss';
import {convertNonLinearSliderPositionToValue, convertValueToNonLinearSliderPosition, NON_LINEAR_SLIDER_MAX, NON_LINEAR_SLIDER_MIN} from '@Utils/slider.util';

interface BaseFontSizeOptionProps {
  fontSize: number;
  scale: number;
  onUpdateFontSize(fontSize: number, undoable?: boolean): void;
}

export function BaseFontSizeOption({...props}: BaseFontSizeOptionProps): ReactElement<any> {
  const onChangeHandler = (updatedValue: number): void => {
    props.onUpdateFontSize(updatedValue / props.scale, false);
  };

  const onChangeEnded = (updatedValue: number): void => {
    props.onUpdateFontSize(updatedValue / props.scale);
  };

  return (
    <ExponentialSliderOptions
      inputCounterClassName={styles.sliderOptions}
      id="item-font-size-option"
      label={window.i18next.t('pmwjs_size')}
      value={Math.round(props.fontSize * props.scale)}
      onChange={onChangeHandler}
      onChangeEnded={onChangeEnded}
      range={{min: NON_LINEAR_SLIDER_MIN, max: NON_LINEAR_SLIDER_MAX}}
      exponentialFunctionForward={(val: number) => {
        return convertValueToNonLinearSliderPosition(val, FONT_SIZE_MIN, FONT_SIZE_MAX);
      }}
      exponentialFunctionBackward={(val: number) => {
        return convertNonLinearSliderPositionToValue(val, FONT_SIZE_MIN, FONT_SIZE_MAX);
      }}
      size={InputFieldSize.XSMALL}
    />
  );
}
